<template>
	<div
		ref="item"
		:class="[
			'c-grid-item',
			view,
			type,
			{
				selected: isSelected === true,
				selectable: selection.length > 0,
				multiplayer: multiplayer === true,
				clickable: clickable === true,
			},
		]"
		:style="style"
		:data-id="ad.id"
	>
		<div class="c-grid-item__wrapper">
			<div
				class="c-grid-item__inner"
				@mousedown="onClick"
				@touchstart="onTouchStart"
				@touchend.prevent="onTouchEnd"
			>
				<HeaderComponent
					:multiplayer="multiplayer"
					:block="ad.block"
					:ad="ad"
					:shared="shared"
					:isAdmin="isAdmin"
					:labels="labels"
					:view="view"
				></HeaderComponent>

				<div class="c-grid-item__clickable" :style="clickableStyle">
					<span
						v-if="showBulkSelect"
						:class="[
							'c-grid-item__icon c-grid-item__checkbox',
							{ visible: selection.length > 0, active: isSelected === true },
						]"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="3"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<polyline points="20 6 9 17 4 12"></polyline>
						</svg>
					</span>

					<!-- <span
						v-if="showBulkSelect"
						:class="[
							'c-grid-item__icon c-grid-item__clone',
							{ active: isSelected === true },
						]"
						v-tooltip="`AI Clone static ad`"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M13 7C13.5523 7 14 7.44772 14 8C14 10.3085 14.5108 11.7424 15.3842 12.6158C16.2576 13.4892 17.6915 14 20 14C20.5523 14 21 14.4477 21 15C21 15.5523 20.5523 16 20 16C17.6915 16 16.2576 16.5108 15.3842 17.3842C14.5108 18.2576 14 19.6915 14 22C14 22.5523 13.5523 23 13 23C12.4477 23 12 22.5523 12 22C12 19.6915 11.4892 18.2576 10.6158 17.3842C9.74243 16.5108 8.30849 16 6 16C5.44772 16 5 15.5523 5 15C5 14.4477 5.44772 14 6 14C8.30849 14 9.74243 13.4892 10.6158 12.6158C11.4892 11.7424 12 10.3085 12 8C12 7.44772 12.4477 7 13 7ZM13 12.7334C12.7361 13.212 12.4147 13.6453 12.03 14.03C11.6453 14.4147 11.212 14.7361 10.7334 15C11.212 15.2639 11.6453 15.5853 12.03 15.97C12.4147 16.3547 12.7361 16.788 13 17.2666C13.2639 16.788 13.5853 16.3547 13.97 15.97C14.3547 15.5853 14.788 15.2639 15.2666 15C14.788 14.7361 14.3547 14.4147 13.97 14.03C13.5853 13.6453 13.2639 13.212 13 12.7334Z"
								fill="currentColor"
							/>
							<path
								d="M6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5C5 6.48063 4.78279 7.0726 4.4277 7.4277C4.0726 7.78279 3.48063 8 2.5 8C2.22386 8 2 8.22386 2 8.5C2 8.77614 2.22386 9 2.5 9C3.48063 9 4.0726 9.21721 4.4277 9.5723C4.78279 9.9274 5 10.5194 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 10.5194 6.21721 9.9274 6.5723 9.5723C6.9274 9.21721 7.51937 9 8.5 9C8.77614 9 9 8.77614 9 8.5C9 8.22386 8.77614 8 8.5 8C7.51937 8 6.9274 7.78279 6.5723 7.4277C6.21721 7.0726 6 6.48063 6 5.5Z"
								fill="currentColor"
							/>
							<path
								d="M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5C10 2.13341 9.85918 2.47538 9.66728 2.66728C9.47538 2.85918 9.13341 3 8.5 3C8.22386 3 8 3.22386 8 3.5C8 3.77614 8.22386 4 8.5 4C9.13341 4 9.47538 4.14082 9.66728 4.33272C9.85918 4.52462 10 4.86659 10 5.5C10 5.77614 10.2239 6 10.5 6C10.7761 6 11 5.77614 11 5.5C11 4.86659 11.1408 4.52462 11.3327 4.33272C11.5246 4.14082 11.8666 4 12.5 4C12.7761 4 13 3.77614 13 3.5C13 3.22386 12.7761 3 12.5 3C11.8666 3 11.5246 2.85918 11.3327 2.66728C11.1408 2.47538 11 2.13341 11 1.5Z"
								fill="currentColor"
							/>
						</svg>
					</span> -->

					<Renderer
						:shared="shared"
						:multiplayer="multiplayer"
						:standalone="standalone"
						:block="ad.block"
						:single="true"
					></Renderer>

					<span class="c-grid-item__label" v-if="labels"> 1 </span>
				</div>

				<Copy
					v-if="view === '' || view === 'all'"
					:block="ad.block"
					:labels="labels"
				></Copy>

				<Preview v-if="view === 'md'" :block="ad.block"></Preview>

				<Tags v-if="view === 'all'" :ad="ad"></Tags>

				<Metadata
					v-if="
						view === '' || (view === 'all' && ad.block.type !== 'upload-custom')
					"
					:ad="ad"
					:labels="labels"
				>
				</Metadata>

				<Picker
					v-if="view !== 'xs' && ad.block && !shared && !standalone"
					mode="webapp"
					:ad="ad"
					:library="!multiplayer"
					:enableBoardAutosave="enableBoardAutosave"
					:fbsaved="ad.block.isSaved"
					:blockId="ad.block.id"
				></Picker>
			</div>
		</div>
	</div>
</template>

<script>
import HeaderComponent from './header';
import ImageComponent from './image';
import Metadata from './metadata';
import Preview from './preview';
import Copy from './copy';
import Tags from './tags';

import Renderer from '@swipekit/components/renderer/index.vue';

import Picker from '@swipekit/components/picker';

export default {
	components: {
		HeaderComponent,
		ImageComponent,
		Metadata,
		Renderer,
		Picker,
		Preview,
		Copy,
		Tags,
	},

	data: function () {
		return {
			touchStartX: 0,
			touchStartY: 0,
			touchMoved: false,
		};
	},

	props: {
		hideAdModal: {
			type: Boolean,
			default: false,
		},
		labels: {
			type: Boolean,
			default: false,
		},
		ad: {},
		standalone: {
			type: Boolean,
			default: false,
		},
		shared: {
			type: Boolean,
			default: false,
		},
		multiplayer: {
			type: Boolean,
			default: false,
		},
		view: {
			type: String,
			default: function () {
				return 'all';
			},
		},
		enableBoardAutosave: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		type: function () {
			if (this.ad && this.ad.block && this.ad.block.type) {
				return this.ad.block.type;
			}
		},
		clickable: function () {
			if (this.multiplayer) {
				return false;
			}
			if (this.shared) {
				return false;
			}

			return true;
		},
		showBulkSelect: function () {
			if (this.multiplayer) {
				return false;
			}

			if (this.shared) {
				return false;
			}

			if (this.standalone) {
				return false;
			}

			return true;
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		isAdmin: function () {
			return this.$store.getters['users/isAdmin'];
		},
		options: function () {
			return this.$store.getters['app/options'];
		},
		style: function () {
			let gridSize = this.options.gridSize;
			let style = ''; //`width:${gridSize}px`;

			return style;
		},
		clickableStyle: function () {
			let block = this.ad.block;
			if (block.assetType === 'text') {
				// don't show padding at all
				return `padding-bottom:0`;
			}

			let assetRatio = this.getRatio(block);

			let padding = assetRatio * 100;
			let str = `padding-bottom:${padding}%;`;

			return str;
		},
		selection: function () {
			return this.$store.getters['ads/selection'];
		},
		isSelected: function () {
			let selection = this.selection;

			if (!this.ad) {
				return;
			}

			if (!this.ad.id) {
				return;
			}

			if (selection.includes(this.ad.id)) {
				return true;
			}
			return false;
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
	},

	methods: {
		onTouchStart(e) {
			if (e.touches && e.touches.length > 0) {
				this.touchStartX = e.touches[0].clientX;
				this.touchStartY = e.touches[0].clientY;
				this.touchMoved = false;
			}
		},
		onTouchEnd(e) {
			if (e.changedTouches && e.changedTouches.length > 0) {
				const endX = e.changedTouches[0].clientX;
				const endY = e.changedTouches[0].clientY;
				const diffX = Math.abs(endX - this.touchStartX);
				const diffY = Math.abs(endY - this.touchStartY);

				const threshold = 10; // px — adjust if needed
				if (diffX < threshold && diffY < threshold) {
					this.onClick(e); // Only trigger if it was a TAP, not a scroll
				}
			}
		},
		getRatio: function (block) {
			let assetRatio = 1;

			if (block.assets && block.assets.length) {
				let asset = block.assets[0];

				if (asset.ratio) {
					assetRatio = asset.ratio;
					return assetRatio;
				}
			}

			if (block.assetRatio) {
				assetRatio = block.assetRatio;
			}

			return assetRatio;
		},
		onSubmit: function (e) {
			this.$emit('onSubmit', e);
		},
		onGotoComment: function () {
			this.$emit('commentClick', this.ad.id, this.$refs.item);
		},
		downloadVideo: function (url) {
			var xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.responseType = 'blob';
			xhr.onload = () => {
				if (xhr.status < 200 || xhr.status >= 300) {
					return;
				}
				var urlCreator = window.URL || window.webkitURL;
				var imageUrl = urlCreator.createObjectURL(xhr.response);
				var tag = document.createElement('a');
				tag.href = imageUrl;
				tag.target = '_blank';
				tag.download = 'sample.mp4';
				document.body.appendChild(tag);
				tag.click();
				document.body.removeChild(tag);
				this.$store.dispatch('events/sendEvent', {
					name: 'ad_download_completed',
					adId: this.ad.id,
				});
			};
			xhr.onerror = (err) => {
				alert('Failed to download picture');
			};
			xhr.send();
		},
		onGotoSource: function () {
			if (this.ad.block.source && this.ad.block.source.url) {
				window.open(this.ad.block.source.url, '_newtab');
			}
		},
		onDownload: function (url, fileName) {
			this.downloadVideo(url);
		},
		onClick: function (e) {
			if (this.view === 'xs') {
				return;
			}

			let pickerButton = '.swipekit-button-new';
			let condition = e.target.closest(pickerButton);
			if (condition) {
				return;
			}

			e.preventDefault();

			let shared = this.shared;
			if (this.selection.length > 0) {
				this.toggleSelection();
				return;
			}

			let clickPrevent = '.click-prevent';
			condition = e.target.closest(clickPrevent);
			if (condition) {
				return;
			}

			let download = `.c-renderer__download`;

			condition = e.target.closest(download);
			if (condition) {
				return;
			}

			let yt = 'lite-youtube';

			condition = e.target.closest(yt);
			if (condition) {
				return;
			}

			let copy = `.btn-copy`;
			condition = e.target.closest(copy);
			if (condition) {
				return;
			}

			let formSave = `.c-form-save-block .btn-primary`;

			condition = e.target.closest(formSave);
			if (condition) {
				return;
			}

			let cta = '.c-cta';

			condition = e.target.closest(cta);
			if (condition) {
				if (this.ad.block.meta.ctaLink) {
					window.open(this.ad.block.meta.ctaLink, '_blank').focus();
					return;
				}
			}

			let carousel = `.VueCarousel`;

			condition = e.target.closest(carousel);

			if (condition) {
				return;
			}

			let checkbox = `.c-grid-item__checkbox`;

			condition = e.target.closest(checkbox);
			if (condition) {
				this.toggleSelection();

				return;
			}

			let aiClone = `.c-grid-item__clone`;

			condition = e.target.closest(aiClone);
			if (condition) {
				this.aiClone();

				return;
			}

			let remove = `.c-grid-item__remove`;

			condition = e.target.closest(remove);
			if (condition) {
				this.removeAd();

				return;
			}

			let link = `.c-ad-link__link`;
			condition = e.target.closest(link);
			if (condition) {
				window.open(e.target.href, '_blank').focus();
				return;
			}

			let comment = `.c-item-footer__comments`;

			condition = e.target.closest(comment);
			if (condition) {
				return;
			}

			let share = `.c-grid-item__share`;

			condition = e.target.closest(share);
			if (condition) {
				window.open('https://swipekit.app', '_blank').focus();
				return;
			}

			let shareAd = `.open-share-ad`;

			condition = e.target.closest(shareAd);
			if (condition) {
				let temp = JSON.parse(JSON.stringify(this.ad));
				this.$store.dispatch('app/setAdShare', temp);
				return;
			}

			condition = e.target.closest('video');
			if (condition) {
				return;
			}

			let dropdownClick = `.open-dropdown`;

			condition = e.target.closest(dropdownClick);
			if (condition) {
				let tempClass = ``;
				condition.classList.forEach((e) => {
					if (e.includes('dropdown-')) {
						tempClass = e;
					}
				});
				this.$emit('onDropdownClick', {
					tempClass: tempClass,
					id: this.ad.id,
				});
				return;
			}

			if (this.hideAdModal) {
				return;
			}

			if (!shared) {
				const videos = this.$refs.item.querySelectorAll('video');
				for (let i = 0; i < videos.length; i++) {
					videos[i].pause();
				}
				this.$store.dispatch('ads/setView', this.ad.id);
			}
		},
		toggleSelection: function () {
			let selection = this.selection;
			if (selection.includes(this.ad.id)) {
				this.$store.dispatch('ads/removeSelection', this.ad.id);
			} else {
				this.$store.dispatch('ads/addSelection', this.ad.id);
			}
		},
		removeAd: function () {
			this.$emit('onRemoveAd', this.ad.id);
		},
		copy: function () {
			let ad = JSON.parse(JSON.stringify(this.ad));
			delete ad.id;
			const str = JSON.stringify(ad);
			navigator.clipboard.writeText(str);
		},
		aiClone: function () {
			this.$store.dispatch('app/setScriptGenerator', this.ad.id);
			console.log(`ai clone`);
		},
	},

	mounted: function () {},
};
</script>

<style lang="scss">
.c-grid-item {
	width: var(--item-width);
	padding: var(--item-padding);
	height: auto;

	&__wrapper {
		position: relative;
	}

	// &__comment {
	// 	position: absolute;
	// 	top: calc(100% - 1px);
	// 	left: 0;
	// 	padding: var(--margin-sm) var(--margin-lg);
	// 	background-color: var(--color-bg-1);
	// 	border-bottom-left-radius: 10px;
	// 	border-bottom-right-radius: 10px;
	// 	white-space: nowrap;
	// 	font-size: var(--font-size-xs);
	// 	font-weight: 500;
	// 	box-shadow: 0px 1px 0.6px rgba(0, 0, 0, 0.085), 0px 3px 6px rgba(0, 0, 0, 0.07);
	// }

	&__inner {
		display: flex;
		flex-direction: column;

		cursor: pointer;

		background-color: var(--color-bg-1);

		transition: box-shadow var(--transition-time-sm) linear;

		box-shadow: rgba(0, 0, 0, 0.075) 0 0 0 1px,
			rgba(0, 0, 0, 0.04) 0px 2px 4px -2px, rgba(0, 0, 0, 0.053) 0px 1px 2px 0px;
		border-radius: var(--item-border-radius);
		user-select: none;
	}

	&.upload-custom {
		.c-grid-item__clickable {
			border-bottom-left-radius: var(--item-border-radius);
			border-bottom-right-radius: var(--item-border-radius);
		}
	}

	&.sm {
		.c-grid-item__clickable {
			border-bottom-left-radius: var(--item-border-radius);
			border-bottom-right-radius: var(--item-border-radius);
		}

		&.multiplayer {
			.c-grid-item__clickable {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}
		}
	}

	&.xs {
		.c-grid-item__clickable {
			aspect-ratio: 9 / 16;
			border-top-left-radius: var(--item-border-radius);
			border-top-right-radius: var(--item-border-radius);
			border-bottom-left-radius: var(--item-border-radius);
			border-bottom-right-radius: var(--item-border-radius);

			.c-renderer {
				&__download {
					display: none;
				}
			}
		}

		.c-grid-item {
			&__icon {
				display: none;
			}
		}

		&.multiplayer {
			.c-grid-item__clickable {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}
		}
	}

	&.md {
		.c-item-preview {
			border-bottom-left-radius: var(--item-border-radius);
			border-bottom-right-radius: var(--item-border-radius);
		}

		&.tiktok-library,
		&.tiktok,
		&.tiktok-top-ads {
			.c-grid-item__clickable {
				border-bottom-left-radius: var(--item-border-radius);
				border-bottom-right-radius: var(--item-border-radius);
			}
		}
	}

	&.all {
		.c-item-metadata {
			overflow: hidden;
			border-bottom-left-radius: var(--item-border-radius);
			border-bottom-right-radius: var(--item-border-radius);
		}
	}

	&.selectable {
		.c-grid-item__inner {
			cursor: pointer;
			&:after {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background-color: hsla(var(--p), 5%, 60%, 0.15);
				transition: background-color var(--transition-time) linear;
				border-radius: var(--item-border-radius);
			}

			&:hover {
				&:after {
					background-color: hsla(var(--p), 60%, 60%, 0.35);
				}
			}
		}
	}

	&.selected {
		.c-grid-item__inner {
			box-shadow: 0 0 0 3px var(--color-primary),
				0px 0.3px 0.8px rgba(0, 0, 0, 0.085), 0px 2px 6px rgba(0, 0, 0, 0.09);

			&:after {
				background-color: hsla(var(--p), 60%, 60%, 0.35);
			}
		}
	}

	&.multiplayer {
		.c-grid-item__inner {
			cursor: initial;
		}
		.c-item-metadata {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;

			&__inner {
				padding-bottom: 1px; // should be 0 but to accomodate box-shadow
			}
		}
		&.upload-custom {
			.c-grid-item__clickable {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}
		}
	}

	&.clickable {
		.c-grid-item__inner {
			&:hover,
			&:active {
				box-shadow: 0 0 0 3px var(--color-primary),
					0px 0.3px 0.8px rgba(0, 0, 0, 0.085), 0px 2px 6px rgba(0, 0, 0, 0.09);
			}
		}
	}

	&__share {
		padding: var(--margin) var(--margin-sm);
		color: var(--color-font);
		opacity: 0.75;
		text-align: center;
		font-weight: 400;
		font-size: var(--font-size-sm);
		text-decoration: none;
	}

	&__clickable {
		position: relative;
		overflow: hidden;

		background-color: var(--color-bg-5);

		transition: box-shadow var(--transition-time) linear;

		.c-renderer {
			width: 100%;
			height: 100%;
			position: absolute;

			.r-facebook .VueCarousel {
				&-slide {
					img {
						display: block;
						width: 100%;
						height: initial;
					}
				}
			}

			&__download {
				opacity: 0;
			}
		}

		.c-item-footer {
			min-height: 48px;
		}

		&:focus,
		&:hover {
			outline: none;

			.c-grid-item__checkbox {
				opacity: 1;
			}

			.c-grid-item__clone {
				opacity: 1;
			}

			.c-grid-item__remove {
				opacity: 1;
			}

			.c-renderer {
				&__download {
					opacity: 1;
				}
			}
		}
	}

	&__icon {
		position: absolute;
		top: var(--margin-lg);
		left: var(--margin-lg);
		width: 32px;
		height: 32px;
		user-select: none;

		border-radius: var(--border-radius-full);
		opacity: 0;
		color: var(--color-button-font);

		display: flex;
		justify-content: center;
		align-items: center;

		&:before {
			content: '';
			position: absolute;
			z-index: 1;
			top: -2px;
			left: -2px;
			width: calc(100% + 4px);
			height: calc(100% + 4px);
			background-color: var(--color-primary);
			border-radius: var(--border-radius-full);
			border: #fff solid 2px;
		}

		svg {
			position: relative;
			z-index: 1;
			width: 60%;
			height: 60%;
			//opacity: 1;
		}

		&.visible {
			opacity: 1;
		}

		&.active {
			color: var(--color-primary);

			&:before {
				background-color: var(--color-button-font);
			}
		}

		&.c-grid-item__clone {
			top: initial;
			bottom: var(--margin-lg);
		}
	}

	&__label {
		position: absolute;
		z-index: 99;
		top: 48px;
		left: 12px;
		width: 24px;
		height: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: var(--color-primary);
		color: var(--color-button-font) !important;
		text-decoration: none !important;
		line-height: 1;
		font-weight: 500;
		font-size: var(--font-size-xs);
		font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
			'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0, 'ss04',
			'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0, 'cv03' 0,
			'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0, 'cv10' 0,
			'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0, 'aalt' 0,
			'calt', 'ccmp', 'locl', 'kern';

		border-radius: 50%;
		box-shadow: 0 0 0 4px hsla(var(--p), 50%, 60%, 0.5);
	}

	&__remove {
		top: calc(var(--margin-lg) * 2 + 32px);
		left: var(--margin-lg);

		&:before {
			background-color: var(--color-danger);
		}

		&.active {
			color: var(--color-danger);
		}
	}

	@media (max-width: 576px) {
		padding: var(--item-padding) 2rem;
	}

	@media screen and (max-width: 400px) {
		padding: var(--item-padding);
	}

	@container (max-width: 4000px) {
		width: 12.5%;
	}

	@container (max-width:2300px) {
		width: 14.28%;
	}

	@container (max-width:2000px) {
		width: 16.6%;
	}
	@container (max-width:1700px) {
		width: 20%;
	}
	@container (max-width:1400px) {
		width: 25%;
	}
	@container (max-width:1060px) {
		width: 33.3%;
	}
	@container (max-width:800px) {
		width: 50%;
	}
	@container (max-width:576px) {
		width: 100%;
	}
}
</style>
